import React from 'react';
import { Form } from 'react-bootstrap';

const ALL_OPTIONS = [
  { value: '00', label: '00 — Tributada integralmente' },
  { value: '10', label: '10 — Tributada + ST' },
  { value: '20', label: '20 — Com redução de BC' },
  { value: '30', label: '30 — Isenta/NT + ST' },
  { value: '40', label: '40 — Isenta' },
  { value: '41', label: '41 — Não tributada' },
  { value: '50', label: '50 — Suspensão' },
  { value: '51', label: '51 — Diferimento' },
  { value: '60', label: '60 — ST cobrado anteriormente' },
  { value: '70', label: '70 — Redução de BC + ST' },
  { value: '90', label: '90 — Outras' },
  { value: '101', label: '101 — Tributada SN c/ crédito' },
  { value: '102', label: '102 — Tributada SN s/ crédito' },
  { value: '103', label: '103 — Isenta p/ faixa receita bruta' },
  { value: '201', label: '201 — Tributada SN c/ crédito + ST' },
  { value: '202', label: '202 — Tributada SN s/ crédito + ST' },
  { value: '203', label: '203 — Isenta p/ faixa + ST' },
  { value: '300', label: '300 — Imune' },
  { value: '400', label: '400 — Não tributada' },
  { value: '500', label: '500 — ST cobrado anteriormente' },
  { value: '900', label: '900 — Outros' },
];

interface Props {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  size?: 'sm' | 'lg';
  isInvalid?: boolean;
}

const SeletorTributacaoICMS = React.forwardRef<HTMLSelectElement, Props & Omit<React.ComponentPropsWithoutRef<'select'>, 'onChange' | 'value' | 'size'>>(
  ({ value, onChange, disabled, size, isInvalid, ...rest }, ref) => {
    return (
      <Form.Select
        ref={ref}
        size={size}
        value={value ?? ''}
        onChange={e => onChange?.(e.target.value)}
        disabled={disabled}
        isInvalid={isInvalid}
        aria-label="CST/CSOSN"
        {...rest}
      >
        <option value="">CST/CSOSN...</option>
        {ALL_OPTIONS.map(o => (
          <option key={o.value} value={o.value}>{o.value} — {o.label.split('—')[1]?.trim()}</option>
        ))}
      </Form.Select>
    );
  }
);

SeletorTributacaoICMS.displayName = 'SeletorTributacaoICMS';

export default SeletorTributacaoICMS;

export const isCSTComST = (cst?: string) =>
  cst === '10' || cst === '30' || cst === '70' || cst === '201' || cst === '202' || cst === '203' || cst === '900';

export const isCSTRetidoAntes = (cst?: string) =>
  cst === '60' || cst === '500';

export const isCSTSemICMS = (cst?: string) =>
  cst === '40' || cst === '41' || cst === '300' || cst === '400' ||
  cst === '50' || cst === '103';

export const isCSTComReducaoBC = (cst?: string) =>
  cst === '20' || cst === '70' || cst === '90' || cst === '900';

export const isCSTComCreditoSN = (cst?: string) =>
  cst === '101' || cst === '201' || cst === '900';
